import React, { useEffect, useState, useRef } from 'react';
import { PitchDeck } from './pages/PitchDeck';
import { AdvantageProduct } from './pages/AdvantageProduct';
import { SummitProduct } from './pages/SummitProduct';
import { SystemPage } from './pages/SystemPage';
import { LeadershipPage } from './pages/LeadershipPage';
import { EdgeProduct } from './pages/EdgeProduct';
import { ComparePage } from './pages/ComparePage';
import { OnePager } from './pages/OnePager';
import { D2DLaunchOnePager } from './pages/D2DLaunchOnePager';
import { LayoutGrid, FileText, Mountain, Calculator, Lock, Crown, GitCompare, Newspaper, Rocket, Layers } from 'lucide-react';
type ViewType = 'deck' | 'edge' | 'advantage' | 'summit' | 'system' | 'leadership' | 'compare' | 'onepager' | 'd2dlaunch';
export function App() {
  // ALL hooks at the top
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [view, setView] = useState<ViewType>('deck');
  // Scroll position management
  const scrollPositions = useRef<Record<string, number>>({});
  // Check auth on mount
  useEffect(() => {
    setIsClient(true);
    const authStatus = localStorage.getItem('site_authenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  // Restore scroll position when view changes
  useEffect(() => {
    // Small timeout to ensure DOM is ready
    const timer = setTimeout(() => {
      window.scrollTo(0, scrollPositions.current[view] || 0);
    }, 0);
    return () => clearTimeout(timer);
  }, [view]);
  // Handler functions
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'HIRE100k' || password === 'TheManny') {
      localStorage.setItem('site_authenticated', 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };
  const handleViewChange = (newView: ViewType) => {
    // Save current scroll position before switching
    scrollPositions.current[view] = window.scrollY;
    setView(newView);
  };
  // Show loading during initial mount
  if (!isClient) {
    return <div className="min-h-screen bg-[#0A0F1C]" data-id="element-0" data-mp="d2bjhk6123x9"></div>;
  }
  // Show login if not authenticated
  if (!isAuthenticated) {
    return <div className="min-h-screen w-full bg-[#0A0F1C] flex items-center justify-center p-4 sm:p-6" data-id="element-1" data-mp="3gkuxpirvf992">
        <div className="w-full max-w-md" data-id="element-2" data-mp="3bn2ys4st6mvd">
          <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-2xl p-6 sm:p-8 shadow-2xl" data-id="element-3" data-mp="3bo4lj6j6sxsx">
            <div className="flex justify-center mb-6" data-id="element-4" data-mp="3qd0ud5t2ieul">
              <div className="w-16 h-16 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 flex items-center justify-center" data-id="element-5" data-mp="3ljpj8sh83bwv">
                <Lock className="w-8 h-8 text-[#7FE0C3]" data-id="element-6" data-mp="2xssf41vo5iw6" />
              </div>
            </div>

            <h1 className="text-xl sm:text-2xl font-bold text-white text-center mb-2" data-id="element-7" data-mp="2stpklbdbev2g">
              Welcome to HIRE
            </h1>
            <p className="text-sm sm:text-base text-slate-400 text-center mb-8" data-id="element-8" data-mp="1d47zjnss9f3v">
              Please enter your access code to continue
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-9" data-mp="yhepawy4ezij">
              <div data-id="element-10" data-mp="13fq0bb05jg2c">
                <label htmlFor="password" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-11" data-mp="13f7ubmnotnh8">
                  Access Code
                </label>
                <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-[#7FE0C3] focus:border-transparent transition-all text-base" placeholder="Enter access code" autoFocus data-id="element-12" data-mp="1w2ki205l41c4" />
              </div>

              {error && <div className="text-red-400 text-sm text-center bg-red-500/10 border border-red-500/20 rounded-lg py-2" data-id="element-13" data-mp="m65huoptjy5v">
                  {error}
                </div>}

              <button type="submit" className="w-full px-4 py-3 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-medium rounded-lg transition-all transform active:scale-95" data-id="element-14" data-mp="c8rftu4n7bx3">
                Access Site
              </button>
            </form>
          </div>
        </div>
      </div>;
  }
  // Main content
  return <div className="relative" data-id="element-15" data-mp="zzoh8cytaqu3">
      {view === 'deck' && <PitchDeck data-id="element-16" data-mp="vv70ynrnuvo2" />}
      {view === 'edge' && <EdgeProduct data-id="element-17" data-mp="vyba7zjzghll" />}
      {view === 'advantage' && <AdvantageProduct data-id="element-18" data-mp="3kob4efudc65t" />}
      {view === 'summit' && <SummitProduct data-id="element-19" data-mp="3klyf1hma6tiq" />}
      {view === 'system' && <SystemPage data-id="element-20" data-mp="3gm7rdms1wtif" />}
      {view === 'leadership' && <LeadershipPage data-id="element-21" data-mp="3gok7due90tsu" />}
      {view === 'compare' && <ComparePage data-id="element-22" data-mp="1w4yivxjntnxx" />}
      {view === 'onepager' && <OnePager data-id="element-23" data-mp="1w69o81sr73r5" />}
      {view === 'd2dlaunch' && <D2DLaunchOnePager data-id="element-24" data-mp="205ihl5jvszm6" />}

      {/* Left Side Buttons - Mobile Optimized */}
      <div className="no-print fixed top-3 left-3 sm:top-6 sm:left-6 z-[100] flex items-center space-x-2" data-id="element-25" data-mp="2553gjfz1x7yw">
        {/* ROI Calculator Button */}
        <a href="https://roi.d2dhire.com" target="_blank" rel="noopener noreferrer" className="px-3 py-2 sm:px-4 sm:py-2 bg-slate-900/90 backdrop-blur-sm border border-slate-700 rounded-full shadow-xl text-slate-400 hover:text-white hover:border-[#7FE0C3]/50 transition-all flex items-center justify-center space-x-2 text-xs sm:text-sm font-medium min-h-[44px]" data-id="element-26" data-mp="29wv6ppeapboi">
          <Calculator className="w-4 h-4" data-id="element-27" data-mp="2su5wmje1esra" />
          <span className="hidden sm:inline" data-id="element-28" data-mp="thle64rd9620">ROI</span>
        </a>
        {/* One-Pager Button */}
        <button onClick={() => handleViewChange('onepager')} title="One-Pager" className={`px-3 py-2 sm:px-4 sm:py-2 backdrop-blur-sm border rounded-full shadow-xl transition-all flex items-center justify-center space-x-2 text-xs sm:text-sm font-medium min-h-[44px] ${view === 'onepager' ? 'bg-[#7FE0C3] text-[#163A5F] border-[#7FE0C3]' : 'bg-slate-900/90 border-slate-700 text-slate-400 hover:text-white hover:border-[#7FE0C3]/50'}`} data-id="element-29" data-mp="ygoejbweio3n">
          <Newspaper className="w-4 h-4" data-id="element-30" data-mp="25va4edp9klu5" />
          <span className="hidden sm:inline" data-id="element-31" data-mp="2kpwt9m6ja0ai">One-Pager</span>
        </button>
        {/* D2D Launch One-Pager Button */}
        <button onClick={() => handleViewChange('d2dlaunch')} title="D2D Launch" className={`px-3 py-2 sm:px-4 sm:py-2 backdrop-blur-sm border rounded-full shadow-xl transition-all flex items-center justify-center space-x-2 text-xs sm:text-sm font-medium min-h-[44px] ${view === 'd2dlaunch' ? 'bg-[#7FE0C3] text-[#163A5F] border-[#7FE0C3]' : 'bg-slate-900/90 border-slate-700 text-slate-400 hover:text-white hover:border-[#7FE0C3]/50'}`} data-id="element-32" data-mp="2fqk4gvw3qj5a">
          <Rocket className="w-4 h-4" data-id="element-33" data-mp="3i3d58yg2kjzi" />
          <span className="hidden sm:inline" data-id="element-34" data-mp="3i4egp40zz8hr">D2D Launch</span>
        </button>
      </div>

      {/* Navigation Toggle - Mobile Optimized */}
      <div className="no-print fixed top-3 right-3 sm:top-6 sm:right-6 z-[100] flex bg-slate-900/90 backdrop-blur-sm border border-slate-700 rounded-full p-1 shadow-xl" data-id="element-35" data-mp="385p8k2ywl2ep">
        <button onClick={() => handleViewChange('deck')} className={`p-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium flex items-center transition-all min-h-[40px] min-w-[40px] justify-center ${view === 'deck' ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} title="Deck" data-id="element-36" data-mp="3d6mpydc39sf5">
          <LayoutGrid className="w-4 h-4" data-id="element-37" data-mp="2uf3nq8pw2ie6" />
          <span className="hidden lg:inline ml-2" data-id="element-38" data-mp="2ubpkky9ei55o">Deck</span>
        </button>
        <button onClick={() => handleViewChange('edge')} className={`p-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium flex items-center transition-all min-h-[40px] min-w-[40px] justify-center ${view === 'edge' ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} title="Edge" data-id="element-39" data-mp="2gf2oexp9vj0t">
          <Layers className="w-4 h-4" data-id="element-40" data-mp="2qweljjsdwjvb" />
          <span className="hidden lg:inline ml-2" data-id="element-41" data-mp="2qvcxmeq9s2w6">Edge</span>
        </button>
        <button onClick={() => handleViewChange('advantage')} className={`p-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium flex items-center transition-all min-h-[40px] min-w-[40px] justify-center ${view === 'advantage' ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} title="Advantage" data-id="element-42" data-mp="2lxbejtsug3kp">
          <FileText className="w-4 h-4" data-id="element-43" data-mp="238522oin887c" />
          <span className="hidden lg:inline ml-2" data-id="element-44" data-mp="2396diu3kmwpl">Advantage</span>
        </button>
        <button onClick={() => handleViewChange('summit')} className={`p-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium flex items-center transition-all min-h-[40px] min-w-[40px] justify-center ${view === 'summit' ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} title="Summit" data-id="element-45" data-mp="1y78pzno51fqu">
          <Mountain className="w-4 h-4" data-id="element-46" data-mp="ipucad2n7jwo" />
          <span className="hidden lg:inline ml-2" data-id="element-47" data-mp="iq41vzjrzp1u">Summit</span>
        </button>
        <button onClick={() => handleViewChange('leadership')} className={`p-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium flex items-center transition-all min-h-[40px] min-w-[40px] justify-center ${view === 'leadership' ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} title="Leadership" data-id="element-48" data-mp="nnmbzt9j4abf">
          <Crown className="w-4 h-4" data-id="element-49" data-mp="4qbdwbzmvmxk" />
          <span className="hidden lg:inline ml-2" data-id="element-50" data-mp="4re3mgl7zjbw">Leadership</span>
        </button>
        <button onClick={() => handleViewChange('compare')} className={`p-2 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium flex items-center transition-all min-h-[40px] min-w-[40px] justify-center ${view === 'compare' ? 'bg-[#7FE0C3] text-[#163A5F] shadow-lg' : 'text-slate-400 hover:text-white'}`} title="Compare" data-id="element-51" data-mp="33es4w5vn2kbr">
          <GitCompare className="w-4 h-4" data-id="element-52" data-mp="2p5kpg70urs8c" />
          <span className="hidden lg:inline ml-2" data-id="element-53" data-mp="2p5uftvpt81ek">Compare</span>
        </button>
      </div>
    </div>;
}